import { useGlobalStore } from 'lib/store';
import { SMSModalStyleConfigData } from './constants';

export default function init({ data }: { data: SMSModalStyleConfigData }) {
  const { smsModalStyleList = [], packageInfoList } = data;
  const smsModalStyleMap: Record<string, string> = {};
  smsModalStyleList.forEach((item) => {
    if (item.packageId) {
      smsModalStyleMap[item.packageId] = item.styleType;
    }
  });

  const globalStore = useGlobalStore.getState();
  globalStore.initGlobalData({
    smsModalStyleMap,
    ...(packageInfoList?.length ? { smsModalPackageInfoList: packageInfoList } : {}),
  });
}
